// const sizeClasses = {
//   xs: "w-7 h-2",
//   sm: "w-9 h-5",
//   md: "w-11 h-6",
//   lg: "w-14 h-7",
// };

// const textSizeClasses = {
//   xs: "text-xs",
//   sm: "text-sm",
//   md: "text-base",
//   lg: "text-lg",
// };

// const ToggleButton = ({
//   label = "",
//   size = "sm", // Default size
//   isChecked = false,
//   onChange,
//   disabled = false,
//   className = "",
// }) => {
//   const secondBox = {
//     xs: "0.95rem",
//     sm: "1rem",
//     md: "1.25rem",
//     lg: "1.5rem",
//   };

//   const translateXValues = {
//     xs: { unchecked: "-5px", checked: "10px" },
//     sm: { unchecked: "0px", checked: "15px" },
//     md: { unchecked: "0px", checked: "18px" },
//     lg: { unchecked: "0px", checked: "26px" },
//   };

//   // Ensure the given `size` exists in translateXValues
//   const selectedTranslateX = translateXValues[size] || translateXValues.lg;

//   return (
//     <label
//       className={`inline-flex items-center ${
//         disabled ? "cursor-not-allowed opacity-50" : "cursor-pointer"
//       } ${className}`}
//     >
//       {label && (
//         <span
//           className={`text-gray-700 mr-2 ${
//             textSizeClasses[size] || textSizeClasses.md
//           }`}
//         >
//           {label}
//         </span>
//       )}
//       <input
//         type="checkbox"
//         className="hidden peer"
//         checked={isChecked}
//         onChange={disabled ? undefined : onChange}
//         disabled={disabled}
//       />
//       <div
//         className={`relative ${
//           sizeClasses[size] || sizeClasses.lg
//         } rounded-full
//           ${
//             isChecked
//               ? disabled
//                 ? "bg-neutrals-700"
//                 : "bg-primary"
//               : "bg-neutrals-700"
//           }`}
//       >
//         <div
//           className={`absolute bg-white transition-transform rounded-full ${
//             size === "xs"
//               ? `-top-[4px] left-[4px] bottom-[2px] border ${
//                   disabled ? "border-neutrals-400 " : "border-neutrals-400"
//                 } ${isChecked ? "border-primary" : "border-neutral-400"}`
//               : "top-[2px] left-[2px]"
//           }`}
//           style={{
//             width: secondBox[size] || secondBox.lg,
//             height: secondBox[size] || secondBox.lg,
//             transform: `translateX(${
//               isChecked
//                 ? selectedTranslateX.checked
//                 : selectedTranslateX.unchecked
//             })`,
//           }}
//         ></div>
//       </div>
//     </label>
//   );
// };

// export default ToggleButton;

const sizeClasses = {
  xs: "w-7 h-2",
  sm: "w-9 h-5",
  md: "w-11 h-6",
  lg: "w-14 h-7",
};

const textSizeClasses = {
  xs: "text-xs",
  sm: "text-sm",
  md: "text-base",
  lg: "text-lg",
};

const ToggleButton = ({
  label = "",
  size = "sm", // Default size
  isChecked = false,
  onChange,
  disabled = false,
  className = "",
  labelPosition = "before", // New prop to control label position
}) => {
  const secondBox = {
    xs: "0.95rem",
    sm: "1rem",
    md: "1.25rem",
    lg: "1.5rem",
  };

  const translateXValues = {
    xs: { unchecked: "-5px", checked: "10px" },
    sm: { unchecked: "0px", checked: "15px" },
    md: { unchecked: "0px", checked: "18px" },
    lg: { unchecked: "0px", checked: "26px" },
  };

  const selectedTranslateX = translateXValues[size] || translateXValues.lg;

  return (
    <label
      className={`inline-flex items-center gap-2 ${
        disabled ? "cursor-not-allowed opacity-50" : "cursor-pointer"
      } ${className}`}
    >
      {label && labelPosition === "before" && (
        <span
          className={`text-gray-700 ${
            textSizeClasses[size] || textSizeClasses.md
          }`}
        >
          {label}
        </span>
      )}
      <input
        type="checkbox"
        className="hidden peer"
        checked={isChecked}
        // onChange={disabled ? undefined : onChange}
        onChange={() => onChange(!isChecked)}
        disabled={disabled}
      />
      <div
        className={`relative ${
          sizeClasses[size] || sizeClasses.lg
        } rounded-full 
          ${
            isChecked
              ? disabled
                ? "bg-neutrals-700"
                : "bg-primary"
              : "bg-neutrals-700"
          }`}
      >
        <div
          className={`absolute bg-white transition-transform rounded-full ${
            size === "xs"
              ? `-top-[4px] left-[4px] bottom-[2px] border ${
                  disabled ? "border-neutrals-400 " : "border-neutrals-400"
                } ${isChecked ? "border-primary" : "border-neutral-400"}`
              : "top-[2px] left-[2px]"
          }`}
          style={{
            width: secondBox[size] || secondBox.lg,
            height: secondBox[size] || secondBox.lg,
            transform: `translateX(${
              isChecked
                ? selectedTranslateX.checked
                : selectedTranslateX.unchecked
            })`,
          }}
        ></div>
      </div>
      {label && labelPosition === "after" && (
        <span
          className={`text-gray-700 ${
            textSizeClasses[size] || textSizeClasses.md
          }`}
        >
          {label}
        </span>
      )}
    </label>
  );
};

export default ToggleButton;
